<div class="container">
  <div class="admin-page-header">
    <h2 class="title admin-page-title">Customer</h2>
    <div class="dialog-actions-wrap">
      <span class="summary-chip">Total: {{ customers.totalElements }}</span>
      <button mat-raised-button color="primary" class="btn-round" (click)="setOpen()">
        <mat-icon>add</mat-icon>
        Nuevo cliente
      </button>
    </div>
  </div>

  <app-filter [filters]="fieldFilters" btLabel="Buscar" (submit)="searchCustomers()"></app-filter>

  <mat-card class="table-card">
    <app-data-table
      [dataSource]="customers.content"
      [displayedColumns]="displayedColumns"
      [emptyMessage]="'No hay clientes disponibles.'"
      [showPaginator]="true"
      [length]="customers.totalElements"
      [pageSize]="customers.size"
      [pageSizeOptions]="[50, 100, 150]"
      [rowClickable]="true"
      (rowClick)="setOpen($event.row)"
      (page)="onPageChange($event)">
      <ng-container matColumnDef="companyName">
        <th mat-header-cell *matHeaderCellDef>Company</th>
        <td mat-cell *matCellDef="let customer">{{ customer.companyName }}</td>
      </ng-container>

      <ng-container matColumnDef="cardId">
        <th mat-header-cell *matHeaderCellDef>Card ID</th>
        <td mat-cell *matCellDef="let customer">{{ customer.cardId }}</td>
      </ng-container>

      <ng-container matColumnDef="email">
        <th mat-header-cell *matHeaderCellDef>Email</th>
        <td mat-cell *matCellDef="let customer">{{ customer.email }}</td>
      </ng-container>

      <ng-container matColumnDef="phone">
        <th mat-header-cell *matHeaderCellDef>Phone</th>
        <td mat-cell *matCellDef="let customer">{{ customer.phone }}</td>
      </ng-container>
    </app-data-table>
  </mat-card>
</div>
